import {percentOfTotal} from '../../helpers';

export const sumOtherCostSection = (otherAdjustment,glidePath, Total) => {

    const summedTotal =
        Number(otherAdjustment) + Number(glidePath);

    return [
        {
            detail: 'Other Adjustment Cost',
            cost: otherAdjustment,
            percentOfTotal: percentOfTotal (Total, otherAdjustment),
        },

        {
            detail: 'Glidepath Cost',
            cost: glidePath !== ''?glidePath :0.0,
            percentOfTotal: percentOfTotal (Total, glidePath),
        },
        {
            detail: 'Total',
            cost: summedTotal,
            percentOfTotal: percentOfTotal (Total, summedTotal),
        },
    ];
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/subSectionMapping/otherCostSection.js